import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
} from '@angular/forms';
import { CalendarForm, CalendarFormKey } from './calendar-form';
import { HeaderForm, HeaderFormKeys } from './header-form';
import { ShiftPlanTemplate } from './shift-plan-template';
import { ConflictSetting } from './shift-plan.interface';

export interface ShiftPlanForm<T extends FormArray<AbstractControl>> {
  [ShiftPlanFormKey.Header]: FormGroup<HeaderForm>;
  [ShiftPlanFormKey.Calendar]: FormGroup<CalendarForm<T>>;
  [ShiftPlanFormKey.TotalDays]: FormControl<number>;
}

export enum ShiftPlanFormKey {
  Header = 'header',
  Calendar = 'calendar',
  TotalDays = 'totalDays',
}

export type ShiftPlanFormValue = {
  [ShiftPlanFormKey.Header]: {
    [HeaderFormKeys.Name]: string;
    [HeaderFormKeys.DateRange]: [Date, Date];
    [HeaderFormKeys.Rolling]: boolean;
    [HeaderFormKeys.ConflictSetting]: ConflictSetting;
    [HeaderFormKeys.OrgUnit]: string;
  };
  [ShiftPlanFormKey.Calendar]: {
    [CalendarFormKey.Users]: (string | null)[];
    [CalendarFormKey.Templates]: ShiftPlanTemplate[];
  };
  [ShiftPlanFormKey.TotalDays]: number;
};

export function planStart(value: ShiftPlanFormValue): Date {
  return value[ShiftPlanFormKey.Header][HeaderFormKeys.DateRange][0];
}

export function planEnd(value: ShiftPlanFormValue): Date {
  return value[ShiftPlanFormKey.Header][HeaderFormKeys.DateRange][1];
}

export function planName(value: ShiftPlanFormValue): string {
  return value[ShiftPlanFormKey.Header][HeaderFormKeys.Name];
}

export interface SplitView {
  patternStart: string;
  splitDate: string;
  dayBefore: string;
}
